import { createSlice } from '@reduxjs/toolkit'
//import {useDispatch} from 'react-redux'
import axios from 'axios'

const login = createSlice({
  name: 'login',
  initialState: {
    email: '',
    password: ''
  },
  reducers: {
    setEmail: ( state, action ) => {
      let url = 'https://api-ganymede2.interactive1.hr/login';
      const authData = {
        email: action.payload.email,
        password: action.payload.password
      }
      //const dispatch = useDispatch();

      axios.post(url, authData)
          .then(res => {

            if (res.status === 200) {
              console.log(res);
              const authCreds = {
                token: res.data.token,
              }
              return authCreds;
            }
            throw res;
          })
          .then(authCreds => {
            /*dispatch({
              type: "login",
              payload: authCreds
            })*/
          })
          .catch(error => {

          });
      state.email = action.payload.email
      state.password = action.payload.password
    }
  }
})

export const getEmail = ( state ) => state.login.email

export default login



